import View from '@play-co/timestep-core/lib/ui/View';
import ScrollView from '@play-co/timestep-core/lib/ui/ScrollView';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import uiConfig from 'src/lib/ui/config';

type CreateItem<TItem> = (superview: View, index: number, item: TItem) => View;

export default class Scroll<TItem = string | {}> {
  private scroll: ScrollView;
  private background: ImageScaleView;

  constructor(
    private opts: {
      superview: View;
      createItem: CreateItem<TItem>;

      showBg?: boolean;
      margin?: number;
      image?: string;
      rect?: {
        x: number;
        y: number;
        width: number;
        height: number;
      };
      firstItemOffset?: number;

      horizontal?: boolean;
    },
  ) {
    const { x, y, width, height } = opts.rect || {
      x: 0,
      y: 0,
      width: opts.superview.style.width,
      height: opts.superview.style.height,
    };

    if (opts.showBg) {
      this.background = new ImageScaleView({
        ...uiConfig.popups.scrollBox,
        image: opts.image || uiConfig.popups.scrollBox.image,
        superview: opts.superview,
        x,
        y,
        width,
        height: height + 1,
      });
    }

    this.scroll = new ScrollView({
      superview: opts.superview,
      x,
      y: y + 1,
      width,
      height: height - 2,
      scrollX: !!this.opts.horizontal,
      scrollY: !this.opts.horizontal,
    });
  }

  getView() {
    return this.scroll;
  }

  getBackgroundView() {
    return this.background;
  }

  setItems(items: TItem[]) {
    // Remove old items.
    this.scroll.removeAllSubviews();

    // Add new items.
    const views = items.map((item, index) => {
      return this.opts.createItem(this.scroll, index, item);
    });

    // Reflow.
    const margin = this.opts.margin || 10;
    let offset = margin + (this.opts.firstItemOffset || 0);

    for (const view of views) {
      if (!view) {
        continue;
      }

      if (this.opts.horizontal) {
        view.style.x = offset;
        offset += view.style.width + margin;
      } else {
        view.style.y = offset;
        offset += view.style.height + margin;
      }
    }

    // Update bounds.
    if (this.opts.horizontal) {
      this.scroll.setScrollBounds({ minX: 0, maxX: offset });
    } else {
      this.scroll.setScrollBounds({ minY: 0, maxY: offset });
    }
  }
}
